import L from "leaflet";
import "leaflet-easybutton/src/easy-button.css";
import { SatelliteView, StreetView, Streetmap_blkwht_view } from "../../../../utils/imageSource";

function MapControl(props) {
  const mapInstance = props.map;
  const delayLoader = 500;
  let defaultLayer1 = null, defaultLayer2 = null;
    const Streetmap_blkwht_url =
      "https://tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png";
  const Satellitemap_url =
    "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}";
  const streetMapURL = 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}';
  var toggle = L.easyButton({
    position: "bottomleft", // topleft, topright, bottomleft, bottomright

    states: [
      {
        stateName: "add-blkwht-view",
        icon:
          '<img class="zoom-in zoom-btn" src="' +
          Streetmap_blkwht_view +
          '" alt="black and white view"/>',
        title: "Show black and white map view",
        onClick: function (control) {
          // alert(1);
          defaultLayer1 = L.tileLayer(Streetmap_blkwht_url).addTo(mapInstance);
          setTimeout(function() {
            //your code to be executed after 1 second
            control.state("add-sattelite-view");
          }, delayLoader);
        },
      },
      {
        stateName: "add-sattelite-view",
        icon:
          '<img class="zoom-in zoom-btn" src="' +
          SatelliteView +
          '" alt="sattelite view"/>',
        title: "Show sattelite map view",
        onClick: function (control) {
          // alert(2);
          defaultLayer2 = L.tileLayer(Satellitemap_url).addTo(mapInstance);
          setTimeout(function() {
            //your code to be executed after 1 second
            control.state("remove-blkwht-view");
          }, delayLoader);
          
        },
      },
      {
        stateName: "remove-blkwht-view",
        icon:
          '<img class="zoom-in zoom-btn" src="' +
          StreetView +
          '" alt="street view"/>',
        onClick: function (control) {
          // alert(3);
          // mapInstance.removeLayer(defaultLayer0);
          // mapInstance.removeLayer(defaultLayer1);
          // mapInstance.removeLayer(defaultLayer2);
          L.tileLayer(streetMapURL).addTo(mapInstance);
          setTimeout(function() {
            //your code to be executed after 1 second
            control.state("add-blkwht-view");
          }, delayLoader);
        },
        title: "Show normal map view",
      },
    ],
  });

  toggle.addTo(mapInstance);
  return null;
}
export default MapControl;
